module.exports = __webpack_public_path__ + "static/img/slide_2_en.cd1c5b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/slider/slide_2_en.svg
// module id = RkJk
// module chunks = 0